import { Component, Input } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { ApplicantInterviewQuestionTypes } from '../../enums/applicant-interview-question-types.enum';
import { JobPostingInterviewOpinionScaleTypes } from '../../enums/job-posting-interview-opinion-scale-types.enum';

@Component({
    selector: 'app-job-posting-interview-questions-preview',
    templateUrl: './job-posting-interview-questions-preview.template.html',
    styleUrls: ['./job-posting-interview-questions-preview.style.scss'],
})
export class JobPostingInterviewQuestionsPreviewComponent {
    @Input() isSecondaryVariant = false;
    @Input() interviewQuestions: InterviewQuestion[] = [];

    applicantInterviewQuestionTypes = ApplicantInterviewQuestionTypes;
    jobPostingInterviewOpinionScaleTypes = JobPostingInterviewOpinionScaleTypes;

    isMarginSetOnInterviewQuestion(interviewQuestion: InterviewQuestion): boolean {
        return (
            this.isSecondaryVariant &&
            interviewQuestion.interviewQuestionType?.name !== this.applicantInterviewQuestionTypes.openQuestion &&
            interviewQuestion.questionTypeMode !== this.jobPostingInterviewOpinionScaleTypes.numerical
        );
    }
}
